import { Link } from 'react-router-dom';

const Footer = () => {
  const whatsappMessage = encodeURIComponent('Merhaba, izmirtadilatfirmasi.com web siteniz üzerinden yazıyorum.\nTadilat, dekorasyon ve iç mimarlık hizmetleriniz hakkında bilgi ve fiyat teklifi almak istiyorum.');

  return (
    <footer className="bg-[#1f1f1f] text-white">
      <div className="container mx-auto px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* KOLON 1 - Firma Tanıtım */}
          <div>
            <h3 className="text-xl font-bold text-white mb-6">İzmir Tadilat Firması</h3>
            <p className="text-sm leading-relaxed text-gray-300">
              İzmir'in en güvenilir tadilat ve dekorasyon firması. Profesyonel ekibimiz ve kaliteli hizmet anlayışımızla hayalinizdeki mekanları gerçeğe dönüştürüyoruz.
            </p>
          </div>

          {/* KOLON 2 - Hızlı Menü */}
          <div>
            <h4 className="text-base font-semibold text-white mb-6">Hızlı Menü</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Anasayfa
                </Link>
              </li>
              <li>
                <Link to="/hakkimizda" className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Hakkımızda
                </Link>
              </li>
              <li>
                <Link to="/hizmetler" className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Hizmetler
                </Link>
              </li>
              <li>
                <Link to="/referanslar" className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Referanslar
                </Link>
              </li>
              <li>
                <Link to="/iletisim" className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">
                  İletişim
                </Link>
              </li>
              <li>
                <Link to="/kvkk" className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">
                  KVKK Aydınlatma Metni
                </Link>
              </li>
              <li>
                <Link to="/cerez" className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Çerez Politikası
                </Link>
              </li>
            </ul>
          </div>

          {/* KOLON 3 - Hizmetler */}
          <div>
            <h4 className="text-base font-semibold text-white mb-6">Hizmetler</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/hizmetler" className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Banyo Tadilatı
                </Link>
              </li>
              <li>
                <Link to="/hizmetler" className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Mutfak Tadilatı
                </Link>
              </li>
              <li>
                <Link to="/hizmetler" className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Anahtar Teslim Tadilat
                </Link>
              </li>
              <li>
                <Link to="/hizmetler" className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Komple Daire Tadilatı
                </Link>
              </li>
              <li>
                <Link to="/hizmetler" className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Cafe Tadilatı
                </Link>
              </li>
              <li>
                <Link to="/hizmetler" className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Mimari Tasarım
                </Link>
              </li>
              <li>
                <Link to="/hizmetler" className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Dış Cephe Uygulamaları
                </Link>
              </li>
              <li>
                <Link to="/hizmetler" className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Çatı ve İzolasyon
                </Link>
              </li>
            </ul>
          </div>

          {/* KOLON 4 - İletişim */}
          <div>
            <h4 className="text-base font-semibold text-white mb-6">İletişim</h4>
            <div className="space-y-4 mb-6">
              <div className="flex items-start space-x-3">
                <i className="ri-phone-line text-lg text-gray-300 mt-0.5"></i>
                <a href="tel:05421138110" className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer">
                  +90 542 113 81 10
                </a>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-mail-line text-lg text-gray-300 mt-0.5"></i>
                <a href="mailto:izmirtadilatfirmasi@gmail.com" className="text-sm text-gray-300 hover:text-white transition-colors cursor-pointer break-all">
                  izmirtadilatfirmasi@gmail.com
                </a>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-lg text-gray-300 mt-0.5"></i>
                <p className="text-sm text-gray-300">
                  Mehmet Ali Akman Mahallesi 20/1 Sokak No:5<br />Konak / İzmir
                </p>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-global-line text-lg text-gray-300 mt-0.5"></i>
                <span className="text-sm text-gray-300">izmirtadilatfirmasi.com</span>
              </div>
            </div>

            {/* Butonlar */}
            <div className="space-y-3">
              <a
                href={`https://wa.me/905421138110?text=${whatsappMessage}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center space-x-2 bg-[#25D366] hover:bg-[#20BA5A] text-white px-6 py-3 rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer w-full"
              >
                <i className="ri-whatsapp-line text-lg"></i>
                <span className="text-sm font-medium">WhatsApp'tan Teklif Al</span>
              </a>
              <a
                href="tel:05421138110"
                className="flex items-center justify-center space-x-2 bg-[#8B6F47] hover:bg-[#6F5838] text-white px-6 py-3 rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer w-full"
              >
                <i className="ri-phone-line text-lg"></i>
                <span className="text-sm font-medium">Hemen Ara</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Alt Şerit */}
      <div className="border-t border-[#2f2f2f]">
        <div className="container mx-auto px-6 py-5">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-3 md:space-y-0">
            <p className="text-xs text-gray-400 text-center md:text-left">
              &copy; 2026 İzmir Tadilat Firması – Tüm Hakları Saklıdır.
            </p>
            <div className="flex items-center space-x-4">
              <Link to="/kvkk" className="text-xs text-gray-400 hover:text-white transition-colors whitespace-nowrap">
                KVKK Aydınlatma Metni
              </Link>
              <span className="text-gray-600">|</span>
              <Link to="/cerez" className="text-xs text-gray-400 hover:text-white transition-colors whitespace-nowrap">
                Çerez Politikası
              </Link>
            </div>
          </div>
          <div className="text-center mt-4">
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-gray-500 hover:text-gray-400 transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
